module.exports = __webpack_public_path__ + "img/116.4f43aff2.svg";